{
  "title": "Dispatch Order",
  "subtitle": "Raise customer dispatch orders for Finished/Semi-Finished Goods.",
  "add": "New Dispatch Order",
  "view": "View",
  "edit": "Edit",
  "release": "Release",
  "close": "Close",
  "save": "Save",
  "cancel": "Cancel",
  "table": {
    "number": "Order Number",
    "customer": "Customer",
    "material": "Material",
    "type": "Type",
    "warehouse": "Warehouse",
    "requestedQty": "Requested Qty",
    "issuedQty": "Issued Qty",
    "pickedQty": "Picked Qty",
    "status": "Status",
    "actions": "Actions",
    "dispatchOrder": "Dispatch Order",
    "date": "Date",
    "issuedBy": "Issued By",
    "lines": "Lines",
    "client": "Client",
    "toWarehouse": "→ {{warehouse}}",
    "qty": "Qty"
  },
  "form": {
    "customer": "Customer",
    "warehouse": "Warehouse",
    "destinationCustomer": "Customer",
    "destinationWarehouse": "Warehouse",
    "destinationWarehouseField": "Destination Warehouse",
    "destinationWarehouseHint": "Everything downstream (pick list, material issue, packing, loading) works exactly as it does for a customer order.",
    "client": "Client",
    "clientHelperNeedsCustomer": "Select a Customer first — only Clients mapped to it are offered here.",
    "remarks": "Remarks",
    "lines": "Lines (Finished Goods)",
    "material": "Finished Good",
    "linesAll": "Lines (Material)",
    "materialAll": "Material",
    "quantity": "Qty",
    "addLine": "Add Line"
  },
  "pickList": {
    "title": "Dispatch Pick List",
    "subtitle": "Generate and review the pick list for a released dispatch order — Material Issue can only post once a pick list exists.",
    "generate": "Generate Pick List",
    "selectOrder": "Dispatch Order",
    "selectOrderHint": "Only released, still-open orders that don't already have a pick list are shown.",
    "location": "Location",
    "batch": "Batch",
    "barcode": "Barcode",
    "requiredQty": "Required Qty",
    "table": {
      "number": "Pick List Number"
    }
  },
  "materialIssue": {
    "title": "Dispatch Material Issue",
    "subtitle": "Confirm and post a generated dispatch pick list — barcode-verify each line, then issue.",
    "selectPickList": "Dispatch Pick List",
    "scanBarcode": "Scan Barcode",
    "scanBarcodeHelper": "Scan or type this line's barcode to confirm you're issuing the physical unit in hand.",
    "scannedOfTotal": "{{scanned}} / {{total}}",
    "scanned": "Scanned",
    "expectedBarcode": "Barcode to Scan: {{barcode}}",
    "noBarcodeBlocked": "Barcode Required is enabled in Process Configuration, but this item has no barcode or printed label — assign a Material barcode or print GRN labels before dispatching.",
    "qtyToIssue": "Qty to Issue",
    "warehouseStock": "Warehouse Stock: {{qty}}",
    "locationStock": "Location Stock: {{qty}}",
    "overStock": "Only {{qty}} available — reduce Qty to Issue.",
    "requestedQty": "Requested Qty: {{qty}}",
    "remaining": "Remaining: {{qty}}",
    "issueButton": "Issue Materials",
    "issuing": "Issuing...",
    "historyTitle": "Recent Issues"
  },
  "receive": {
    "title": "Warehouse Transfer Receipt",
    "subtitle": "Receive material dispatched from another warehouse — the destination half of a Warehouse-destination dispatch order.",
    "selectOrder": "Dispatch Order",
    "selectOrderHint": "Only orders dispatched to another of this company's own warehouses, with something still in transit, are shown.",
    "nothingPending": "Nothing is in transit right now.",
    "bulkLocation": "Assign All To Location",
    "bulkLocationHelper": "Sets the same destination location on every row below — each can still be changed individually.",
    "scanBarcodeHelper": "Scan or type this label's barcode to confirm you're receiving the physical unit in hand.",
    "qtyToReceive": "Qty to Receive",
    "location": "Destination Location",
    "expiry": "Expiry",
    "receiveButton": "Receive Material",
    "receiving": "Receiving...",
    "historyTitle": "Recent Receipts",
    "table": {
      "number": "Receipt Number",
      "destination": "Destination Warehouse",
      "receivedBy": "Received By"
    }
  }
}
